












































































import {Component, Prop, Watch} from 'vue-property-decorator';
import {Client, Measurement} from "@/core/services/MedicaPro/models";
import {Api} from "@/core/services/MedicaPro/Api";
import {BaseList} from "@/core/components/BaseList";
import bus from "@/main";
import DateView from "@/components/Shared/DateView.vue";
import MeasurementListRowValueView
    from "@/components/Admin/Clients/Details/Components/MeasurementList/Components/MeasurementList-RowValueView.vue";
import MeasurementListRowObjectiveValueView
    from "@/components/Admin/Clients/Details/Components/MeasurementList/Components/MeasurementList-RowObjectiveValueView.vue";
import MeasurementListCreateNew
    from "@/components/Admin/Clients/Details/Components/MeasurementList/Components/MeasurementList-CreateNew.vue";
import MeasurementListToolbar
    from "@/components/Admin/Clients/Details/Components/MeasurementList/Components/MeasurementList-Toolbar.vue";
import {Filter} from "@/components/Admin/Clients/Details/Components/MeasurementList/Helpers/Filter";

@Component({
    components: {
        MeasurementListToolbar,
        MeasurementListCreateNew, MeasurementListRowObjectiveValueView, MeasurementListRowValueView, DateView}
})
export default class ClientDetailsPageMeasurementListView extends BaseList {

    // Bindings to parent
    @Prop() client!: Client;
    @Prop() category?: string;
    @Prop() presetIdentifiers?: string[];

    // Bindings to view
    public modelName = 'measurement';
    public items: Measurement[] = [];
    public headers = [
        {text: 'Type', value: 'type', sortable: false},
        {text: 'Dato', value: 'date', sortable: false},
        {text: 'Objektiv værdi', value: 'objective-value', sortable: false},
        {text: 'Lægens score', value: 'doctors-assessment', sortable: false},
        {text: 'Kommentar', value: 'comment', sortable: false},
        {text: '', value: 'actions', sortable: false},
    ];
    public filter = new Filter();

    public created() {
        super.created();

        this.subscribe(this.filter.onChange.subscribe(() => this.getItems(true, true)));

        this.filter.setCategory(this.category);
        this.filter.setIdentifiers(this.presetIdentifiers);
    }

    public mounted() {
        super.mounted();
    }

    protected getItems(doItems = true, doCount = false) {
        // Get options from DataTable
        const options: any = this.options;

        // Mark as Loading
        this.loading = true;

        // Prepare API call
        const api = Api.measurements().get()
            .where('client_id', this.client.id!);

        this.filter.applyApiFilters(api);

        if (doItems) {
            api
                .limit(options.itemsPerPage)
                .offset(options.itemsPerPage * (options.page - 1))
                .orderDesc('date')
                .find(items => {
                    this.items = items;
                    this.loading = false;
                });
        }

        // Count total amount of items
        if (doCount) {
            api.count(count => {
                this.totalItems = count;
            });
        }
    }

    public editItem(item: Measurement) {
        bus.$emit(`${this.modelName}Edit`, item);
    }

    public editComment(item: Measurement) {
        bus.$emit(`measurementCommentEdit`, item);
    }

    @Watch('presetIdentifiers')
    public onPresetIdentifiersChange() {
        this.filter.setIdentifiers(this.presetIdentifiers, true);
    }

}
